import type { TagProps } from 'antd';

type AntTagColor = TagProps['color'];

/**
 * Build a status→Tag color lookup with a default fallback.
 *
 * Domain helpers should stay thin wrappers when:
 * - status vocabularies differ (decision vs assignment vs invoice vs pipeline), or
 * - colors need alias resolution / multi-key maps (interview stages).
 * Use this factory when the mapping is a plain enum→preset color table.
 */
export function createStatusColorLookup<T extends string>(
  colors: Record<T, AntTagColor>,
  fallback: AntTagColor = 'default',
): (status: T | string | null | undefined) => AntTagColor {
  return (status) => {
    if (status == null) return fallback;
    if (Object.prototype.hasOwnProperty.call(colors, status)) {
      return colors[status as T];
    }
    return fallback;
  };
}
